import React from "react";
import { Stack, TextField } from "@mui/material";

interface ScalePointRowProps {
  level: number;
  title: string;
  description: string;
  placeholder?: string;
  onTitleChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
}

/**
 * One scale-point row used in L2 rating-scale config.
 * Renders a 0..5 purple numbered badge + title TextField + description multiline.
 */
const ScalePointRow: React.FC<ScalePointRowProps> = ({
  level,
  title,
  placeholder = "",
  description,
  onTitleChange,
  onDescriptionChange,
}) => (
  <Stack
    direction="row"
    gap={3}
    p={4}
    sx={{
      bgcolor: (theme) => (theme.palette as any).grayscale?.[50] ?? "#F6F7F8",
      borderRadius: 4,
    }}
  >
    <Stack
      aria-hidden
      alignItems="center"
      justifyContent="center"
      sx={{
        width: 20,
        height: 20,
        borderRadius: "50%",
        bgcolor: "primary.main",
        color: "primary.contrastText",
        fontSize: 12,
        fontWeight: 600,
        flexShrink: 0,
        mt: "2px",
      }}
    >
      {level}
    </Stack>
    <Stack flex={1} gap={2}>
      <TextField
        size="small"
        fullWidth
        placeholder={placeholder}
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        aria-label={`Scale point ${level} title`}
      />
      <TextField
        size="small"
        multiline
        minRows={2}
        fullWidth
        placeholder={`Operational definition for score ${level}...`}
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        aria-label={`Scale point ${level} description`}
      />
    </Stack>
  </Stack>
);

export default ScalePointRow;
